var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.643.75H6.964l-.21-.438A.53.53 0 0 0 6.275 0H3.723a.53.53 0 0 0-.478.312L3.036.75H.357A.366.366 0 0 0 0 1.125v.75a.366.366 0 0 0 .357.375h9.286A.366.366 0 0 0 10 1.875v-.75A.366.366 0 0 0 9.643.75m-8.455 10.2A1.1 1.1 0 0 0 2.257 12h5.486a1.1 1.1 0 0 0 1.069-1.055L9.286 3H.714z"
  })));
};
export default SvgTrash;